import {Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {DatagridComponent} from "../../ui/datagrid/datagrid.component";
import * as moment from 'moment';
import {EventService} from "../../core/services/event.service";

declare var $: any;

@Component({
    selector: 'cat-page',
    templateUrl: './mail.html'
})

export class MailPage implements OnInit {
    @ViewChild('addressBookTable', { static: true })
    datagrid: DatagridComponent;
    addressBookGridOptions = {
        data:  [
            // {
            //     name: 'Jon Zendell',
            //     email: 'zendell@optonline.net',
            //     firstDonationDate: '7/16/2012',
            //     mostRecentDonationDate: '8/21/2012'
            // }
        ],
        columns: [
            // {
            //     type: 'checkbox',
            //     idProperty: 'constituentAddressBooksId',
            //     class: 'text-center',
            //     data: 'checked',
            //     width: '10%'
            // },
            {
                title: 'First Name',
                data: 'firstName'
            },
            {
                title: 'Last Name',
                data: 'lastName'
            },
            {
                title: 'Email',
                data: 'email',
                responsivePriority: 1
            },
            {
                title: 'First Donation Date',
                data: 'firstDonationDate',
                class: 'date-col',
                type: 'date',
                render: (x) => {
                    return ((x === null) ? null : moment.utc(x).format('MM/DD/YYYY'));
                }
            },
            {
                title: 'Most Recent Donation Date',
                data: 'lastDonationDate',
                type: 'date',
                class: 'date-col',
                render: (x) => {
                    return ((x === null) ? null : moment.utc(x).format('MM/DD/YYYY'));
                }
            }
        ]
    };

    constructor(private activatedRoute: ActivatedRoute,
                private modalService: NgbModal,
                public eventService: EventService) {
        this.addressBookGridOptions.data = this.activatedRoute.snapshot.data['constituentAddressBooks'];
    }

    openModal(content) {
        this.modalService.open(content);
    }

    ngOnInit() {

        $(function () {

            ///////////////////////////////////////////////////
            // SIDEBAR CURRENT STATE
            $('.cat__apps__messaging__tab').on('click', function () {
                $('.cat__apps__messaging__tab').removeClass('cat__apps__messaging__tab--selected');
                $(this).addClass('cat__apps__messaging__tab--selected');
            });

            ///////////////////////////////////////////////////
            // DATATABLES
            $('#example1').DataTable({
                responsive: true,
                "order": [],
                "columnDefs": [{
                    "targets": 'no-sort',
                    "orderable": false
                }],
                "lengthMenu": [[20, 50, 100, -1], [20, 50, 100, "All"]]
            });

        });

    }
}

